import { Component, Input, OnInit } from '@angular/core';
import { faArrowUpRightFromSquare } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-links',
  templateUrl: './links.component.html',
  styleUrls: ['./links.component.scss'],
})
export class LinksComponent implements OnInit {
  constructor() {}

  @Input() account: string;
  @Input() profileImage: string;
  @Input() links = [];

  isLoading = true;
  openIcon = faArrowUpRightFromSquare;

  ngOnInit() {}

  navigateToLink = (url) => window.open(url, '_blank');
}
